import { API_BASE } from '../config.js';
import type { BoardSettings } from '@multirx/shared/types/board.js';

export async function fetchBoardSettings(): Promise<BoardSettings> {
  const res = await fetch(`${API_BASE}/api/board-settings`);
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error((err as { error?: string }).error ?? 'Erreur lors du chargement des réglages');
  }
  return res.json() as Promise<BoardSettings>;
}

export async function updateBoardSettings(settings: BoardSettings): Promise<BoardSettings> {
  const res = await fetch(`${API_BASE}/api/board-settings`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(settings),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error((err as { error?: string }).error ?? 'Erreur lors de l’enregistrement');
  }
  return res.json() as Promise<BoardSettings>;
}
